// generated by srcset-codegen
import src from "./postal-fun-nav-logo.png";
import src2x from "./postal-fun-nav-logo@2x.png";
import src3x from "./postal-fun-nav-logo@3x.png";

const width = 150;
const height = 17;
const srcSet = `${src2x} 2x, ${src3x} 3x`;
export default { src, width, height, srcSet };
